export default __webpack_public_path__ + "static/media/rubocop.c025f852.svg";